import React, { useState, useEffect } from 'react';
import { motion } from 'framer-motion';

const FinancierAccreditationBadge = ({ isOpen, onClose, addToCart, currency, convertCurrency }) => {
  const [selectedBadge, setSelectedBadge] = useState(null);
  const [expandedFeatures, setExpandedFeatures] = useState({});

  const financierBadges = [
    {
      name: "PREMIUM FINANCIER INDUSTRY BADGE",
      price: 155,
      details: "(1 BADGE)",
      summary: [
        "• Forum",
        "• Investor's Room",
        "• Film Finance Market",
        "And More"
      ],
      features: [
        "Enjoy premium opportunities at AFFF",
        "Enjoy red-carpet privileges at AFFF",
        "Get one-on-one conversations with top film industry experts with tailored strategic projects for your unique needs at AFFF Investors Room",
        "Get direct access to AFFF accredited film industry professionals for engaging in confidential negotiations and acquiring strategic investment insights at AFFF Investors Room",
        "Promote your project's funding offers to AFFF accredited film industry professionals at AFFF Investors Room",
        "Enjoy a premium networking environment with top-tier investors and industry leaders at AFFF Investors Lounge",
        "Complimentary tea and coffee breaks at the AFFF Investors Lounge",
        "Complimentary lunch at the AFFF Investors Lounge",
        "Access bespoke investment opportunities aligned with your strategic goals at the AFFF Investors Room",
        "Benefit from matchmaking services to connect with AFFF accredited seasoned industry experts from diverse sectors; tourism, sustainability, sports, military etc. at AFFF Lounge",
        "Experience engaging and diverse entertainment throughout the forum",
        "Access Insights on Maximizing Your ROI in Film Financing Forum session",
        "Participate in VIP think tanks and brainstorming sessions with industry leaders from the film and finance industry at the Forum",
        "Access to insight of potential investment opportunities of film projects at AFFF Finance Forum",
        "Enjoy best seat reservation at the AFFF Film Financing Forum",
        "Learn how to collaborate with other sectors for film financing at AFFF industry integration session",
        "Gain access to Industry leaders from other sector such as sustainability, health, military, tourism etc. for film collaboration at AFFF industry integration session",
        "Access to extensive resources and learning materials designed to expand your knowledge and expertise of the film financing at AFFF Master Class",
        "Benefit from expert-led sessions and class that enhance your investment strategies and knowledge at the AFFF Master Class",
        "Get certification from a premium film finance academy at the AFFF Master Class",
        "Get privileged access to film projects from accredited AFFF film industry professionals at AFFF Pitch Competition",
        "Attend AFFF private dinners and cocktails designed for deep, impactful networking",
        "Witness cutting-edge demonstrations of revolutionary film technologies and services at the AFFF Exhibition/Showcase",
        "Gain privileged access to build valuable relationships with tourism boards and location managers, creating opportunities for future collaborations and joint ventures at AFFF CineTour",
        "Access to AFFF Film Premier",
        "Enjoy the recognition and prestige associated with elite status of Premium Elite Financier Industry professional at the AFFF event",
        "Benefit from a reserved VIP parking spot at the AFFF venue for unparalleled convenience and ease",
        "Benefit from enhanced media exposure and promotional opportunities at AFFF event",
        "Enjoy the opportunity to book meetings with AFFF key stakeholders and attendees",
        "Engage with key stakeholders and thought leaders in a high-impact forum at the AFFF event",
        "Win exclusive prizes through our thrilling raffles at AFFF",
        "Receive a custom event itinerary based on your interests and goals",
        "Attend invitation-only receptions with key stakeholders at AFFF",
        "Amplify your presence and influence among top film industry professionals at AFFF",
        "Dedicated VIP check-in at AFFF"
      ]
    },
    {
      name: "PREMIUM ELITE FINANCIER INDUSTRY BADGE",
      price: 232,
      details: "(1 BADGE)",
      discount: "10% OFF",
      summary: [
        "• Forum",
        "• Investor's Room",
        "• Film Finance Market",
        "• Pitch Room",
        "• Investor's Lounge",
        "And More"
      ],
      features: [
        "Enjoy elite opportunities at AFFF",
        "Enjoy elite red-carpet privileges at AFFF",
        "Get one-on-one conversations with top film industry experts with tailored strategic projects for your unique needs at AFFF Investors Room",
        "Get direct access to AFFF accredited film industry professionals for engaging in confidential negotiations and acquiring strategic investment insights at AFFF Investors Room",
        "Promote your project's funding offers to AFFF accredited film industry professionals at AFFF Investors Room",
        "Be invited to contribute to advisory boards that shape future industry developments and investment strategies at AFFF Private Executive Film Investment Roundtable",
        "Establish impactful connections with AFFF stakeholders, opening doors to new opportunities and collaborations at AFFF Private Executive Film Investment Roundtable",
        "Participate in an in-depth analysis of market trends and emerging opportunities at AFFF Private Executive Film Investment Roundtable",
        "Become an active member of committees shaping the future of film finance at AFFF Private Executive Film Investment Roundtable",
        "Enjoy a premium networking environment with top-tier investors and industry leaders at AFFF Investors Lounge",
        "Complimentary tea and coffee breaks at the AFFF Investors Lounge",
        "Complimentary lunch at the AFFF Investors Lounge",
        "Access bespoke investment opportunities aligned with your strategic goals at the AFFF Investors Room",
        "Benefit from matchmaking services to connect with AFFF accredited seasoned industry experts from diverse sectors; tourism, sustainability, sports, military etc. at AFFF Lounge",
        "Experience engaging and diverse entertainment throughout the forum",
        "Access Insights on Maximizing Your ROI in Film Financing Forum session",
        "Participate in VIP think tanks and brainstorming sessions with industry leaders from the film and finance industry at the Forum",
        "Access to insight of potential investment opportunities of film projects at AFFF Finance Forum",
        "Enjoy best seat reservation at the AFFF Film Financing Forum",
        "Learn how to collaborate with other sectors for film financing at AFFF industry integration session",
        "Gain access to Industry leaders from other sector such as sustainability, health, military, tourism etc. for film collaboration at AFFF industry integration session",
        "Access to extensive resources and learning materials designed to expand your knowledge and expertise of the film financing at AFFF Master Class",
        "Benefit from expert-led sessions and class that enhance your investment strategies and knowledge at the AFFF Master Class",
        "Get certification from a premium film finance academy at the AFFF Master Class",
        "Get privileged access to film projects from accredited AFFF film industry professionals at AFFF Pitch Competition",
        "Attend AFFF private dinners and cocktails designed for deep, impactful networking",
        "Witness cutting-edge demonstrations of revolutionary film technologies and services at the AFFF Exhibition/Showcase",
        "Gain privileged access to build valuable relationships with tourism boards and location managers, creating opportunities for future collaborations and joint ventures at AFFF CineTour",
        "Access to AFFF Film Premier",
        "Enjoy the recognition and prestige associated with elite status of Premium Elite Financier Industry professional at the AFFF event",
        "Benefit from a reserved VIP parking spot at the AFFF venue for unparalleled convenience and ease",
        "Benefit from enhanced media exposure and promotional opportunities at AFFF event",
        "Enjoy the opportunity to book meetings with AFFF key stakeholders and attendees",
        "Engage with key stakeholders and thought leaders in a high-impact forum at the AFFF event",
        "Win exclusive prizes through our thrilling raffles at AFFF",
        "Receive a custom event itinerary based on your interests and goals",
        "Attend invitation-only receptions with key stakeholders at AFFF",
        "Amplify your presence and influence among top film industry professionals at AFFF",
        "Dedicated VIP check-in at AFFF"
      ]
    },
    {
      name: "PREMIUM ELITE PLUS FINANCIER INDUSTRY BADGE",
      price: 265,
      details: "(1 BADGE)",
      summary: [
        "• Forum",
        "• Deal Table",
        "• Investor's Room",
        "• Film Finance Market",
        "• Pitch at the Pitch Room",
        "• Investor's Lounge",
        "And More"
      ],
      features: [
        "Access entry to restricted areas and elite events at AFFF",
        "Enjoy exceptional VIP opportunities at AFFF",
        "Enjoy elite red-carpet privileges at AFFF",
        "Gain privileged access to high-stakes projects and investment opportunities from AFFF accredited film industry professionals with assured ROI at AFFF Deal Table",
        "Get one-on-one conversations with top film industry experts with tailored strategic projects for your unique needs at AFFF Investors Room",
        "Get direct access to AFFF accredited film industry professionals for engaging in confidential negotiations and acquiring strategic investment insights at AFFF Investors Room",
        "Promote your project's funding offers to AFFF accredited film industry professionals at AFFF Investors Room",
        "Be invited to contribute to advisory boards that shape future industry developments and investment strategies at AFFF Private Executive Film Investment Roundtable",
        "Establish impactful connections with AFFF stakeholders, opening doors to new opportunities and collaborations at AFFF Private Executive Film Investment Roundtable",
        "Participate in an in-depth analysis of market trends and emerging opportunities at AFFF Private Executive Film Investment Roundtable",
        "Become an active member of committees shaping the future of film finance at AFFF Private Executive Film Investment Roundtable",
        "Enjoy a premium networking environment with top-tier investors and industry leaders at AFFF Investors Lounge",
        "Complimentary tea and coffee breaks at the AFFF Investors Lounge",
        "Complimentary lunch at the AFFF Investors Lounge",
        "Access bespoke investment opportunities aligned with your strategic goals at the AFFF Investors Room",
        "Benefit from matchmaking services to connect with AFFF accredited seasoned industry experts from diverse sectors; tourism, sustainability, sports, military etc. at AFFF Lounge",
        "Experience engaging and diverse entertainment throughout the forum",
        "Access Insights on Maximizing Your ROI in Film Financing Forum session",
        "Participate in VIP think tanks and brainstorming sessions with industry leaders from the film and finance industry at the Forum",
        "Access to insight of potential investment opportunities of film projects at AFFF Finance Forum",
        "Enjoy best seat reservation at the AFFF Film Financing Forum",
        "Learn how to collaborate with other sectors for film financing at AFFF industry integration session",
        "Gain access to Industry leaders from other sector such as sustainability, health, military, tourism etc. for film collaboration at AFFF industry integration session",
        "Access to extensive resources and learning materials designed to expand your knowledge and expertise of the film financing at AFFF Master Class",
        "Benefit from expert-led sessions and class that enhance your investment strategies and knowledge at the AFFF Master Class",
        "Get certification from a premium film finance academy at the AFFF Master Class",
        "Get privileged access to film projects from accredited AFFF film industry professionals at AFFF Pitch Competition",
        "Attend AFFF private dinners and cocktails designed for deep, impactful networking",
        "Witness cutting-edge demonstrations of revolutionary film technologies and services at the AFFF Exhibition/Showcase",
        "Gain privileged access to build valuable relationships with tourism boards and location managers, creating opportunities for future collaborations and joint ventures at AFFF CineTour",
        "Access to AFFF Film Premier",
        "Enjoy the recognition and prestige associated with elite status of Premium Elite Plus Financier Industry professional at the AFFF event",
        "Benefit from a reserved VIP parking spot at the AFFF venue for unparalleled convenience and ease",
        "Benefit from enhanced media exposure and promotional opportunities at AFFF event",
        "Enjoy the opportunity to book meetings with AFFF key stakeholders and attendees",
        "Engage with key stakeholders and thought leaders in a high-impact forum at the AFFF event",
        "Win exclusive prizes through our thrilling raffles at AFFF",
        "Receive a custom event itinerary based on your interests and goals",
        "Attend invitation-only receptions with key stakeholders at AFFF",
        "Amplify your presence and influence among top film industry professionals at AFFF",
        "Dedicated VIP check-in at AFFF"
      ]
    },
    {
      name: "CORPORATE PLAN",
      price: 1800,
      details: "(COMPANY PLAN)",
      summary: [
        "• Own an AFFF Investors Room",
        "• Deal Table",
        "• Media Coverage",
        "• Elite Corporate Networking",
        "And More"
      ],
      features: [
        "Own an AFFF Investors Room to showcase your financiers' offers to over 3,000 participants from the film and finance industries",
        "Access entry to restricted areas and elite events at AFFF",
        "Enjoy exceptional VIP opportunities at AFFF",
        "Enjoy elite red-carpet privileges at AFFF",
        "Gain privileged access to high-stakes projects and investment opportunities from AFFF accredited film industry professionals with assured ROI at AFFF Deal Table",
        "Get one-on-one conversations with top film industry experts with tailored strategic projects for your unique needs at AFFF Investors Room",
        "Get direct access to AFFF accredited film industry professionals for engaging in confidential negotiations and acquiring strategic investment insights at AFFF Investors Room",
        "Promote your project's funding offers to AFFF accredited film industry professionals at AFFF Investors Room",
        "Be invited to contribute to advisory boards that shape future industry developments and investment strategies at AFFF Private Executive Film Investment Roundtable",
        "Establish impactful connections with AFFF stakeholders, opening doors to new opportunities and collaborations at AFFF Private Executive Film Investment Roundtable",
        "Participate in an in-depth analysis of market trends and emerging opportunities at AFFF Private Executive Film Investment Roundtable",
        "Become an active member of committees shaping the future of film finance at AFFF Private Executive Film Investment Roundtable",
        "Enjoy a premium networking environment with top-tier investors and industry leaders at AFFF Investors Lounge",
        "Complimentary tea and coffee breaks at the AFFF Investors Lounge",
        "Complimentary lunch at the AFFF Investors Lounge",
        "Access bespoke investment opportunities aligned with your strategic goals at the AFFF Investors Room",
        "Benefit from matchmaking services to connect with AFFF accredited seasoned industry experts from diverse sectors; tourism, sustainability, sports, military etc. at AFFF Lounge",
        "Experience engaging and diverse entertainment throughout the forum",
        "Access Insights on Maximizing Your ROI in Film Financing Forum session",
        "Participate in VIP think tanks and brainstorming sessions with industry leaders from the film and finance industry at the Forum",
        "Access to insight of potential investment opportunities of film projects at AFFF Finance Forum",
        "Enjoy best seat reservation at the AFFF Film Financing Forum",
        "Learn how to collaborate with other sectors for film financing at AFFF industry integration session",
        "Gain access to Industry leaders from other sector such as sustainability, health, military, tourism etc. for film collaboration at AFFF industry integration session",
        "Access to extensive resources and learning materials designed to expand your knowledge and expertise of the film financing at AFFF Master Class",
        "Benefit from expert-led sessions and class that enhance your investment strategies and knowledge at the AFFF Master Class",
        "Get certification from a premium film finance academy at the AFFF Master Class",
        "Get privileged access to film projects from accredited AFFF film industry professionals at AFFF Pitch Competition",
        "Attend AFFF private dinners and cocktails designed for deep, impactful networking",
        "Witness cutting-edge demonstrations of revolutionary film technologies and services at the AFFF Exhibition/Showcase",
        "Gain privileged access to build valuable relationships with tourism boards and location managers, creating opportunities for future collaborations and joint ventures at AFFF CineTour",
        "Access to AFFF Film Premier",
        "Enjoy the recognition and prestige associated with elite status of Premium Elite Plus Financier Industry professional at the AFFF event",
        "Benefit from a reserved VIP parking spot at the AFFF venue for unparalleled convenience and ease",
        "Benefit from enhanced media exposure and promotional opportunities at AFFF event",
        "Enjoy the opportunity to book meetings with AFFF key stakeholders and attendees",
        "Engage with key stakeholders and thought leaders in a high-impact forum at the AFFF event",
        "Win exclusive prizes through our thrilling raffles at AFFF",
        "Receive a custom event itinerary based on your interests and goals",
        "Attend invitation-only receptions with key stakeholders at AFFF",
        "Amplify your presence and influence among top film industry professionals at AFFF",
        "Dedicated VIP check-in at AFFF"
      ]
    }
  ];

  // Set the PREMIUM ELITE FINANCIER INDUSTRY BADGE as default selection
  useEffect(() => {
    if (isOpen && financierBadges.length > 0) {
      const defaultBadge = financierBadges.find(badge => badge.name === "PREMIUM ELITE FINANCIER INDUSTRY BADGE");
      setSelectedBadge(defaultBadge || financierBadges[0]);
    }
  }, [isOpen]);

  const toggleFeatures = (badgeName) => {
    setExpandedFeatures(prev => ({
      ...prev,
      [badgeName]: !prev[badgeName]
    }));
  };

  const handleBadgeSelection = (badge) => {
    setSelectedBadge(badge);
  };

  const handleGetBadge = (badge) => {
    if (addToCart && badge) {
      addToCart({
        name: badge.name,
        price: badge.price,
        quantity: 1,
        type: 'badge'
      });
    }
  };

  if (!isOpen) return null;

  return (
    <motion.div 
      className="fixed inset-0 z-50 bg-black bg-opacity-80 flex items-center justify-center overflow-y-auto"
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      exit={{ opacity: 0 }}
    >
      <div className="container mx-auto px-4 py-8">
        <div className="bg-white rounded-lg shadow-xl overflow-hidden max-w-6xl mx-auto">
          <div className="p-6 bg-custom-base text-white">
            <div className="flex justify-between items-center">
              <h2 className="text-3xl font-bold">Secure Your Spot with an Access Badge</h2>
              <button 
                onClick={onClose}
                className="text-white p-2 rounded-full hover:bg-opacity-20 hover:bg-white transition-colors"
              >
                <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
                </svg>
              </button>
            </div>
            <p className="mt-2">Select the badge that best suits your needs to access exclusive AFFF events and networking opportunities.</p>
          </div>

          <div className="grid md:grid-cols-4 gap-4 p-6">
            {financierBadges.map((badge) => {
              const isSelected = selectedBadge?.name === badge.name;
              const isExpanded = expandedFeatures[badge.name];
              const displayedFeatures = isExpanded ? badge.features : badge.features.slice(0, 8);
              
              return (
                <div 
                  key={badge.name}
                  className={`border rounded-lg overflow-hidden transition-all duration-300 hover:shadow-lg ${
                    isSelected ? 'border-2 border-custom-red transform scale-[1.02]' : 'border-gray-200'
                  }`}
                  onClick={() => handleBadgeSelection(badge)}
                >
                  {badge.discount && (
                    <div className="bg-custom-red text-white py-1 px-3 text-center text-sm font-semibold">
                      {badge.discount}
                    </div>
                  )}
                  
                  <div className="p-4">
                    <h3 className="text-lg font-bold text-custom-base">{badge.name}</h3>
                    <div className="flex items-baseline mt-2">
                      <span className="text-2xl font-bold">${badge.price}</span>
                      <span className="ml-2 text-gray-600 text-sm">{badge.details}</span>
                    </div>
                    
                    <div className="bg-blue-50 p-3 rounded-md border border-blue-100 my-4">
                      <div className="text-xs text-gray-600 mb-1 font-lexend">Access to:</div>
                      <ul className="text-sm list-none space-y-1 font-lexend">
                        {badge.summary.map((item, index) => (
                          <li key={index} className={item.includes("And More") ? "text-custom-red font-bold" : ""}>
                            {item}
                          </li>
                        ))}
                      </ul>
                    </div>
                    
                    <div className="mt-4">
                      <h4 className="font-semibold text-sm mb-2">Features:</h4>
                      <ul className="text-sm space-y-2">
                        {displayedFeatures.map((feature, index) => (
                          <li key={index} className="flex items-start">
                            <span className="text-custom-red mr-2">•</span>
                            <span>{feature}</span>
                          </li>
                        ))}
                      </ul>
                      
                      {badge.features.length > 8 && (
                        <button 
                          className="text-custom-red font-semibold text-sm mt-3 hover:underline"
                          onClick={(e) => {
                            e.stopPropagation();
                            toggleFeatures(badge.name);
                          }}
                        >
                          {isExpanded ? "Show Less" : "Show More"}
                        </button>
                      )}
                    </div>
                    
                    <button 
                      className={`w-full py-2 px-4 rounded-md font-semibold text-sm mt-4 ${
                        isSelected 
                          ? 'bg-custom-red text-white' 
                          : 'bg-gray-100 text-gray-700 hover:bg-gray-200'
                      }`}
                      onClick={(e) => {
                        e.stopPropagation();
                        handleGetBadge(badge);
                      }}
                    >
                      Get Badge
                    </button>
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </motion.div>
  );
};

export default FinancierAccreditationBadge; 